module.exports = __webpack_public_path__ + "img/p8.b133958.png";